/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LinkedInChatListItem } from './linkedInChatListItem';
import type { TabCounts } from './tabCounts';

/**
 * ``GET /inbox/chats`` response envelope.
 */
export interface LinkedInChatListResponse {
  items: LinkedInChatListItem[];
  next_cursor?: string | null;
  tab_counts: TabCounts;
}
